import { Booking } from "PFTypes";
import React from "react";

import BookingDetail from "../../parts/overview/detail_view/booking_detail";
import SidePanel from "../../parts/overview/side_panel";
import EngagementDetail from "./detail_view/engagement_detail";
import { ProfileDetail } from "./detail_view/profile_detail";
import RoleDetail from "./detail_view/role_detail";
import { DetailsPanelData } from "./details_panel_context_provider";
import { usePrerequisiteChecker } from "./use_prerequisite_checker";

export interface DetailsPanelComponentProps {
  data: DetailsPanelData;
  onDeleted: (booking: Booking) => Promise<void>;
  onEdited: () => void;
  onClose: () => void;
}

const detailComponents: Record<DetailsPanelData["type"], React.FC<DetailsPanelComponentProps>> = {
  booking: BookingDetail,
  engagement: ({ data, onClose }) => <EngagementDetail data={data} onClose={onClose} />,
  profile: ({ data, onClose }) => <ProfileDetail data={data} onClose={onClose} />,
  role: ({ data, onClose }) => <RoleDetail data={data} onClose={onClose} />
};

export const DetailsPanel = ({
  data,
  onClose,
  onDeleted,
  onEdited
}: DetailsPanelComponentProps): JSX.Element => {
  const Component = data?.type && detailComponents[data.type];
  const checkIfSidePanelCanBeDisplayed = usePrerequisiteChecker({ data });
  const canDisplaySidePanel = checkIfSidePanelCanBeDisplayed({ type: data?.type });
  const show = !!data && canDisplaySidePanel;
  return (
    <SidePanel show={show}>
      {Component ? (
        <Component data={data} onDeleted={onDeleted} onEdited={onEdited} onClose={onClose} />
      ) : (
        JSON.stringify(data)
      )}
    </SidePanel>
  );
};
